import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { BotOwnerPreviewService } from './bot-owner-preview.service';

@Injectable()
export class BotOwnerPreviewInterceptor implements HttpInterceptor {
  constructor(private previewService: BotOwnerPreviewService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const viewAs = this.previewService.activeViewAs;
    if (!viewAs || !request.url.startsWith('api/internal/guild')) {
      return next.handle(request);
    }

    return next.handle(
      request.clone({
        setHeaders: {
          'X-RO-View-As': viewAs,
        },
      })
    );
  }
}
